import { useState } from "react";

export function isRequired(value) {
  let status = false;
  if (value) {
    if (typeof value === "number") {
      if (value !== -1) {
        status = true;
      }
    }
    if (typeof value !== "number") {
      if (value.trim().length > 0) {
        status = true;
      }
    }
  }
  return status;
}

export function validate(validations, values) {
  const errors = validations
    .map((validation) => validation(values))
    .filter((validation) => typeof validation === "object");
  return {
    isValid: errors.length === 0,
    errors: errors.reduce((errors, error) => ({ ...errors, ...error }), {}),
  };
}

export function useForm(
  initialState = {},
  validations = [],
  onSubmit = () => {}
) {
  const { isValid: initialIsValid, errors: initialErrors } = validate(
    validations,
    initialState
  );
  const [values, setValues] = useState(initialState);
  const [arrayvalues, setarrayValues] = useState([]);
  const [errors, setErrors] = useState(initialErrors);
  const [isValid, setValid] = useState(initialIsValid);
  const [touched, setTouched] = useState({});

  const changeHandler = (event) => {
    const newValues = { ...values, [event.target.name]: event.target.value };
    const { isValid, errors } = validate(validations, newValues);
    setValues(newValues);
    setValid(isValid);
    setErrors(errors);
    setTouched({ ...touched, [event.target.name]: true });
  };

  const customHandler = (value, names) => {
    const newValues = { ...values, [names]: value };
    const { isValid, errors } = validate(validations, newValues);
    setValues(newValues);
    setValid(isValid);
    setErrors(errors);
    setTouched({ ...touched, names: true });
  };

  const editHandler = (initValues) => {
    setValues(initValues);
  };

  const clearHandler = () => {
    setValues(initialState);
  };

  const blastChange = (data) => {
    setValues(data);
  };

  const multiFieldHandler = (fieldMap) => {
    const newValues = { ...values, ...fieldMap };
    const { isValid, errors } = validate(validations, newValues);
    setValues(newValues);
    setValid(isValid);
    setErrors(errors);
  };

  const submitHandler = (event) => {
    event.preventDefault();
    onSubmit(values);
  };

  const changeHandlerTermin = (event) => {
    console.log(event);
    if (event.target.checked) {
      const newValues = { ...values, [event.target.name]: event.target.value };
      const { isValid, errors } = validate(validations, newValues);
      setValues(newValues);
      setValid(isValid);
      setErrors(errors);
      setTouched({ ...touched, [event.target.name]: true });
    } else {
      delete values[event.target.name];
      setTouched({ ...touched, [event.target.name]: false });
    }
  };

  const changeArrayHandler = (event, name) => {
    var tmparr = event
    console.log(tmparr)
    // arrayvalues.push(event)
    // tmparr[name].push(event)
    // var arr = [name]: tmparr 
    const newValues = { ...values, [name]: tmparr };
    const { isValid, errors } = validate(validations, newValues);
    setValues(newValues);
    setarrayValues(tmparr);
    setValid(isValid);
    setErrors(errors);
    // setTouched({ ...touched, [event.target.name]: true });
  }
  return {
    values,
    changeHandler,
    editHandler,
    clearHandler,
    isValid,
    errors,
    touched,
    customHandler,
    submitHandler,
    blastChange,
    multiFieldHandler,
    changeHandlerTermin,
    changeArrayHandler
  };
}
